import {
  SET_CURRENT_SEARCH_INFO,
  SET_MENU_COLLAPSED,
  SET_APPLICATION_INFO,
  SET_SOUND_STATE,
  SET_NEWTASK_STATE,
  SET_MENUTASKFLAG_STATE,
  SET_MENU_OPEN_LIST,
  SET_AI_PRODUCT_DETAIL_INFO,
  CURRENT_STATUS,
  SET_PREV_PAGE,
  SET_CURRENT_REPORT_TIME,
  SET_CURRENT_CT_REPORT_TIME,
  NATIONAL_DICT,
  IDTYPE_DICT,
  CARDTYPE_DICT,
} from '../constants/ActionTypes.js';

export const setCurrentSearchInfo = data => ({
  type: SET_CURRENT_SEARCH_INFO,
  data,
});

export const setCurrentReportTime = data => ({
  type: SET_CURRENT_REPORT_TIME,
  data,
});

export const setCurrentCTReportTime = data => ({
  type: SET_CURRENT_CT_REPORT_TIME,
  data,
});

export const nationalDict = data => ({
  type: NATIONAL_DICT,
  data,
});

export const IDTypeDict = data => ({
  type: IDTYPE_DICT,
  data,
});

export const cardTypeDict = data => ({
  type: CARDTYPE_DICT,
  data,
});

export const setMenuCollapsed = data => ({
  type: SET_MENU_COLLAPSED,
  data,
});

export const setApplicationInfo = data => ({
  type: SET_APPLICATION_INFO,
  data,
});

export const setAIProductDetailInfo = data => ({
  type: SET_AI_PRODUCT_DETAIL_INFO,
  data,
});

export const setSoundState = data => ({
  type: SET_SOUND_STATE,
  data,
});
export const newTaskState = data => ({
  type: SET_NEWTASK_STATE,
  data,
});

export const changeMenuTaskFn = data => ({
  type: SET_MENUTASKFLAG_STATE,
  data,
});

export const setMenuOpenList = data => ({
  type: SET_MENU_OPEN_LIST,
  data,
});

export const clearCurrentInfo = data => ({
  type: CURRENT_STATUS,
  data,
});

export const setPrevPage = data => ({
  type: SET_PREV_PAGE,
  data,
});
